export default {
  today: 'TODAY',
  noJobs: 'No jobs posted',
  bonusWorkers: {
    one: '+1 bonus worker',
    many: '+%num% bonus workers',
  },
};
